<template>
  <div class="z-layout">
    <left-menu :isCollapse="isCollect" @select="select"></left-menu>
    <Main @setCollect="setCollect" :isCollect="isCollect"></Main>
  </div>
</template>

<script>
  import LeftMenu from '@/components/leftmenu'
  import Main from '@/components/main'
  import USERAPI from '@/api/user';
  import S  from '@/utils/website'
  export default {
    components: {
      'left-menu': LeftMenu,
      'Main': Main,
    },
    data() {
      return {
        //收缩
        isCollect: false
      }
    },
    methods: {
      //触发收缩功能
      setCollect(v) {
        if (v == false) {
          this.isCollect = true;
        }
        if (v == true) {
          this.isCollect = false;
        }
      },
      //设置跳转点
      select(item) {
        if (item.name == 'Home') {
          this.$router.push({
            name: item.name
          });
        } else {
          let params = {
            resourceId: item.resourceId
          };
          USERAPI.searchUserResources(params).then(res => {
            //设置权限
            localStorage.setItem(S.auth.ActiveAuth, JSON.stringify(res.data.data))
            this.$router.push({
              name: item.name
            });
          });
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .z-layout {
    display: flex;
    flex-direction: row;
    height: 100vh;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue